module.exports = __webpack_public_path__ + "media/images/badges/rumble/milestone-100-Active-Rumble-11140eb5fe0fbc6f1e5822392e3e2ad8.png";